export const openInNewTabHandler = (link:string, ms:number)=>{
  window.open(link, '_blank');
};